import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { OptionService } from '../../option.service';
import { Users } from '../users.model';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-userslist',
  templateUrl: './userslist.component.html',
  styleUrls: ['./userslist.component.css'],
  queries: {
    contentRef: new ViewChild("ModalNewRole"),
    contentRef2: new ViewChild("ModalConfirmReset"),
    contentRef4: new ViewChild("ModalNewPassword"),
    contentRef5: new ViewChild("ModalConfirmDelete")
  }
})
export class UserslistComponent implements OnInit {

  users: Users[] = [];
  displayedColumns: string[] = ['name', "userName", "role", "options"];
  dataSource!: MatTableDataSource<Users>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  pageSize = 100;
  public contentRef!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef4!: TemplateRef<any>;
  public contentRef5!: TemplateRef<any>;
  roles: { id: number, name: string }[] = [{ id: 1, name: "admin" },
  { id: 2, name: "assistant" },
  { id: 3, name: "mandoob" }
  ];
  spinnerOverlay = false;
  selectedRole: number = 1;
  userId!: string;
  userfullName: string = "";
  userName: string = "";
  newPassword: string = "";
  constructor(private service: UsersService,
    private optionService: OptionService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private globle: Globle) { }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    this.getData();
  }

  getData() {
    this.service.getWebUsers().subscribe(data => {
      this.users = data;
      this.dataSource = new MatTableDataSource(this.users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  onActiveAndDeactivate(user: Users) {

    this.spinnerOverlay = true;
    var obj = {
      userId: user.id,
      status: user.approved == 1 ? 0 : 1
    }

    this.optionService.ChangeUserStatus(obj).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.getData();
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
      })
  }

  onChangeRole(user: Users) {
    this.userId = user.id;
    this.openDialogNewRole();
  }

  openDialogNewRole(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
      height: '300px'
    });
  }

  confirmChangeRole() {

    this.dialog.closeAll();
    this.spinnerOverlay = true;
    var obj = {
      userId: this.userId,
      roleName: this.selectedRole == 1 ? "Admin" : this.selectedRole == 2 ? "Assistant" : "Mandoob"
    }

    this.service.ChangeRole(obj).subscribe(data => {
      this.openSnackBar("تم التخزين بنجاح", 'snackBarSuccess');
      this.getData();

    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
      })
  }

  resetPassword(data: any) {
    this.userfullName = data.name;
    this.userName = data.userName;
    this.openDialogConfirmReset();
  }

  openDialogConfirmReset(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '400px',
    });
  }

  confirmReset() {
    var obj = {
      emailOrPhone: this.userName
    }
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.service.resetAdminPassword(obj).subscribe(data => {
      this.newPassword = data["newPassword"];
      this.openDialogNewPassword();
      this.openSnackBar("تم اعادة تعيين كلمة السر بنجاح", 'snackBarSuccess');

      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  openDialogNewPassword(): void {
    const dialogRef = this.dialog.open(this.contentRef4, {
      width: '400px',
    });
  }

  onNoClick() {
    this.dialog.closeAll();
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  deleteUser(userId: any) {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteUser(userId).subscribe(data => {
      this.openSnackBar("تم الحذف بنجاح", 'snackBarSuccess');
      this.getData();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar("لا يمكن حذف هذا المستخدم", 'snackBarError');

    })
  }

  onDelete(user: any) {
    this.userId = user.id;
    this.openDialogConfirmDelete();
  }

  confirmDelete() {
    this.deleteUser(this.userId);
  }

  openDialogConfirmDelete(): void {
    const dialogRef = this.dialog.open(this.contentRef5, {
      width: '300px',
    });
  }

}
